import React from "react";
import styled from "styled-components";
import defaultThumbnailImage from "@assets/images/default-thumbnail-insight.png";
import { useServices } from "@core/servicesContext";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { Article } from "@domain/lms/article/article";
import { getDisplayedAuthor } from "@domain/lms/utils";
import { ImageVersions } from "@domain/media/dtos";
import { useHover } from "@utils/hooks";
import { BackgroundImage } from "@ui/components/backgroundImage";
import { mobile } from "@ui/styles/utils";
import { CategoryLabel } from "@ui/components/categoryLabel";
import { InsightSmallIcons } from "@ui/components/icons";
import { BookmarkToggle } from "./bookmarkToggle";

interface ArticleThumbnailSmallHaiderProps extends React.HTMLAttributes<HTMLDivElement> {
	article: Article;
	isSmall?: boolean;
}
export const ArticleThumbnailSmallHeader: React.FC<ArticleThumbnailSmallHaiderProps> = ({
	article,
	isSmall,
	...htmlProps
}) => {
	const { banner, category, isFavorite, author } = article;
	const { articleService } = useServices();
	const displayedAuthor = getDisplayedAuthor(article);
	const subAuthor = displayedAuthor !== author ? author : undefined;
	const currentProfile = useCurrentProfile();
	const isAuthor = displayedAuthor.id === currentProfile?.id || subAuthor?.id === currentProfile?.id;
	const { ref, isHovered } = useHover();

	return (
		<Container {...htmlProps} ref={ref}>
			<StyledBackgroundImage
				isHovered={isHovered}
				image={banner}
				defaultUrl={!banner ? defaultThumbnailImage : undefined}
				size={ImageVersions.MEDIUM}
				backdrop
				isBackLinearGradient
			/>
			{category && category !== "OTHERS" && (
				<Category isSmall category={category} renderIcons={() => <InsightSmallIcons color="white" />} />
			)}
			{!isAuthor && (
				<StyledBookmark
					checked={isFavorite}
					onClick={async () => {
						await articleService.toggleFavorite({ ...article });
					}}
				/>
			)}
		</Container>
	);
};

const Container = styled.div`
	position: relative;
`;

const StyledBackgroundImage = styled(BackgroundImage)`
	border-top-left-radius: 13px;
	border-top-right-radius: 13px;
	overflow: hidden;
	height: 210px;
	@media ${mobile} {
		height: 235px;
	}
`;

const Category = styled(CategoryLabel)`
	position: absolute;
	left: 15px;
	top: 15px;

	@media (max-width: 900px) {
		left: 15px;
		top: 15px;
	}
`;
const StyledBookmark = styled(BookmarkToggle)`
	position: absolute;
	top: 15px;
	right: 15px;
`;
